import { render } from "./SuperAdminSidebar.vue?vue&type=template&id=13e31489&scoped=true"
import script from "./SuperAdminSidebar.vue?vue&type=script&lang=js"
export * from "./SuperAdminSidebar.vue?vue&type=script&lang=js"

import "./SuperAdminSidebar.vue?vue&type=style&index=0&id=13e31489&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e31489"]])

export default __exports__